import React, { useState } from 'react';
import './css/RetestRequestSideBar.css';
import { toast } from 'react-toastify';
import { url } from '../../constants/url';
import { useAuth } from '../../Context/UserContext';

export const RetestRequestSideBar = (props) => {

    const { retestRequest, setRetestRequest, projectId } = props;
    const [selectedOptions, setSelectedOptions] = useState([]);
    const { logout } = useAuth()

    const handleCheckboxChange = (id) => {
        if (selectedOptions.includes(id)) {
            setSelectedOptions(selectedOptions.filter(item => item !== id));
        } else {
            setSelectedOptions([...selectedOptions, id]);
        }
    };


    const clientVulSuccess = () => {
        toast.success("Retest applied successfully...", {
            position: "top-right",
            autoClose: 2500,
            pauseOnHover: false,
        });
    };

    const clientVulError = () => {
        toast.error("Try after 30 minutes", {
            position: "top-right",
            autoClose: 2500,
            pauseOnHover: false,
        });
    };

    const handleCancel = () => {
        setSelectedOptions([]);
        setRetestRequest(false);
    };

    if (!retestRequest) return null;

    const options = [
        { id: 'all', label: 'All' },
        { id: 'only-critical', label: 'Only Critical' },
        { id: 'only-high', label: 'Only High' },
        { id: 'only-medium', label: 'Only Medium' },
        { id: 'only-info', label: 'Only Info' },
        { id: 'only-low', label: 'Only Low' },
    ];

    const confirmRetest = async () => {
        const hasSelectedSeverity = Object.values(selectedOptions).some(
            (value) => value
        );
        if (!hasSelectedSeverity) {
            toast.error("Please select at least one severity.", {
                position: "top-right",
                autoClose: 3000,
                pauseOnHover: false,
            });
            return;
        }
        try {

            const response = await fetch(`${url}/applyretest`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include",
                body: JSON.stringify({
                    projectId,
                    selectedSeverities: selectedOptions,
                }),
            });

            if (response.ok) {
                clientVulSuccess();
                setSelectedOptions([]);
                setRetestRequest(false);
                return;
            }
            if (response.status === 406) {
                const errorData = await response.json();
                toast.error("Please try after sometimes", {
                    position: "top-right",
                    autoClose: 3000,
                    pauseOnHover: false,
                });

                setSelectedOptions([]);
                return;
            }
            if (response.status === 440) {
                toast.error("User logout due to inactivity", {
                    position: "top-right",
                    autoClose: 2500,
                    pauseOnHover: false,
                });
                return logout();
            }
            if (response.status === 401) {
                toast.error("Only project owner can apply", {
                    position: "top-right",
                    autoClose: 2500,
                    pauseOnHover: false,
                });

            }
        } catch (error) {
            console.log(error);
            clientVulError();
        }
    };


    return (
        <div className="request-retest_container">
            <div className="request-retest-side-bar">
                <div className="request-retest-side-bar-header">
                    <h2>Retest Request</h2>
                    <button onClick={handleCancel}>X</button>
                </div>

                <div className="request-retest-side-bar-content">
                    <p className="request-retest-side-bar-description">
                        Please select the Severity of the vulnerabilities you would like to apply for the retest.
                    </p>

                    <div className="request-retest-side-bar-checkbox">
                        {options.map((opt) => (
                            <label key={opt.id} className="custom-checkbox-label">
                                <input
                                    type="checkbox"
                                    className="custom-checkbox"
                                    checked={selectedOptions.includes(opt.id)}
                                    onChange={() => handleCheckboxChange(opt.id)}
                                />
                                <span className="custom-checkbox-span"></span>
                                {opt.label}
                            </label>
                        ))}
                    </div>

                    <div className="request-retest-buttons">
                        <button className="cancel-button" onClick={handleCancel}>Cancel</button>
                        <button className="confirm-button" onClick={confirmRetest}>Confirm</button>
                    </div>
                </div>
            </div>
        </div>
    );
};
